// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorOutlinedSvg from "@ant-design/icons-svg/es/asn/CalculatorOutlined";
import AntdIcon from '../components/AntdIcon';

var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorOutlinedSvg
  }));
};

CalculatorOutlined.displayName = 'CalculatorOutlined';
export default React.forwardRef(CalculatorOutlined);